<template>
    <div id="index">
        <div class="visible-xs min_index">
            <header class="flex_center m_header">
                <i class="esc" @click="goBackward"><img src="@/assets/img/esc_fan.png" alt=""></i>
                <h4 class="header_title">麻醉眼界</h4>
            </header>
            <!-- 内容 -->
            <div class='recommended'>
                <div class="recommended_head">
                    <div class="recommended_title flex_start">
                        <span class="tag flex_center">{{ details.activity_id }}号</span>
                        {{ details.title }}
                    </div>
                </div>
                <div class="recommended_center" v-html="details.content">
                </div>
                <div class="container">
                    <div class="flex_center img_li li_r_img" v-for="(liem, index) in details.file" :key="index">
                        <img :src="liem" alt="" />
                    </div>
                </div>
                <!-- 评论 -->
                <div class="comments">
                    <h4 class="comments_title">评论</h4>
                    <div class='comments_ul'>
                        <div class="comments_li " v-for="(liem,index) in comment">
                            <div class="user_text flex_between">
                                <div class="flex_start flex_items">
                                    <img class="portrait" v-if="liem.image" :src="liem.image" alt="">
                                    <img class="portrait" v-else :src="liem.headimage" alt="">
                                    <span class="user_name" v-if="liem.name">{{liem.name}}</span>
                                    <span class="time" v-else>{{liem.username}}</span>
                                </div>
                                <div class="time flex_end">
                                    {{liem.create_time}}
                                </div>
                            </div>
                            <div class="text_center" v-if="liem.type == 1" v-html="liem.content">
                            </div>
                            <div class="text_center li_r_img" v-if="liem.type == 2">
                                <img :src="liem.content" alt="">
                            </div>

                        </div>
                        <div v-if="comment.length<=0" class="complete">暂无评论</div>
                    </div>
                </div>
            </div>
            <!-- /* 底部按钮 */ -->
            <div class="button_buttom flex_between">
                <div class="button_left flex_center" @click="giveFun">
                        <span class="prompt">投票</span>
                    <i class="flex_center">
                        <img v-if="details.is_goods == 0" src="@/assets/img/give.png" alt="">
                        <img v-if="details.is_goods == 1" src="@/assets/img/give_t.png" alt="">
                    </i>
                    <span>{{details.goods}}</span>
                    
                </div>
                <div class="button_right flex_center">
                    <i class="icon_img face-icon expression">
                        <img src="@/assets/img/smilingT.png" alt="" />
                    </i>
                    <input class="inpu_div" type="text" placeholder="说点什么。。。" />
                    <button class="flex_center send" @click.stop="out">发送</button>
                </div>
            </div>
        </div>
        <!-- 提示注册弹窗 -->
        <LoginPrompt @promptFun="promptFun" ref="prompt"></LoginPrompt>
    </div>
</template>

<script>
    import { AnalyticEmotion, Hashtable } from "@/assets/js/sinaFaceAndEffec.js";
    import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //注册弹窗模块
    import "@/assets/js/pcmain.js";
    import "@/assets/css/pcsinaFaceAndEffec.css";
    import "@/assets/css/pcmain.css";
    export default {
        name: "index",
        data() {
            return {
                id: 0, //推文id
                details: {}, //内容

                comment_total: 0,//总数
                comment: [1, 1, 1, 1],//列表
                page: 1,//翻页
                is_app: this.$store.state.is_app,
            };
        },
        computed: {

        },
        components: {
            LoginPrompt
        },
        watch: {

        },
        methods: {
            promptFun() {//提示弹窗回调
                this.$store.commit('queryUrl', '/m_activityDetails?id=' + this.id)
                this.$router.replace({ path: '/m_password', query: {} });
            },
            upImgFun() {
                 
                if (this.is_app) {
                    let that = this;
                    let index = layer.open({
                        title: [
                            '选择方式',
                            'background-color: #FF4351; color:#fff;'
                        ]
                        , content: '<div id="session" style="width: 60%;height: 4rem;border-radius: .6rem;margin: 1rem auto;line-height: 4rem; background: #1AAD19;color:#fff;">拍照</div>' +
                            '<div id="circle"  style="width: 60%;height: 4rem;border-radius: .6rem;margin: 1rem auto;line-height: 4rem; background: #1AAD19;color:#fff;">相册</div>'
                    });
                    $('#session').click(() => {//拍照
                        android.pictureMethod(1);
                        layer.close(index);
                    })
                    $('#circle').click(() => {//相册
                        android.pictureMethod(2);
                        layer.close(index);
                    })
                }
            },
            //   点赞
            giveFun() {
              if (!this.USER() || this.USER().length == 0) {
                    this.$refs.prompt.popupFun();
                    return false;
                }
                let that = this;
                this.$post("activity-goods", {
                    activity_id: this.id,
                    member_id: this.USER().id,
                }).then((res) => {

                    layer.open({
                        content: "点赞成功",
                        time: true,
                        skin: "msg",
                    });
                    that.details.goods = that.details.goods + 1;
                    that.details.is_goods = 1;

                }).catch(error => {
                     
                    layer.open({
                        content: error.message,
                        time: 2,
                        skin: "msg"
                    });
                });
            },
            addImg() {
                $('.li_r_img img').on("click", function () {
                    $(this).ImgZoomIn('');
                });
            },
            judgeUser() {//判断用户数据
                if (this.USER() && this.USER() !== {}) {
                    this.REFRESH_USER();
                } else {
                    this.$refs.prompt.popupFun();
                }
            },
            goBackward() { //返回上一页
                if (window.history.length > 2) {
                    this.$router.go(-1)
                } else {
                    this.$router.replace('/m_home');
                }
            },
            bayFun(e) {//点击回车
                if (e.which == 13) {
                    this.out();
                }
            },
            upImg(img) {
                this.send(img, 2);
            },
            //上传图片
            handleChange: function (e) {
                let _this = this;
                let img = e.target.files[0];
                this.judgeUser();
                let images = "";
                var reader = new FormData();
                reader.append("file", img);
                var layerOpen = layer.open({
                    type: 2
                    , content: '上传中。。。'
                });
                //发送图片消息
                $.ajax({
                    type: "POST", //提交方式
                    url: this.$URL + 'upload', //路径
                    data: reader,
                    processData: false,
                    contentType: false,
                    success: function (result) { //返回数据根据结果进行相应的处理
                        layer.close(layerOpen)
                        _this.upImg(result.data);
                    }
                });
            },
            out: function () {
              if (!this.USER() || this.USER().length == 0) {
                    this.$refs.prompt.popupFun();
                    return false;
                }
                //发送
                var inputText = $(".inpu_div").val();
                if (!inputText) {
                    layer.open({
                        content: "请输入内容",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                this.judgeUser();
                if (this.USER().is_words == 1) {
                    layer.open({
                        content: "你已被禁言!",
                        time: true,
                        skin: "msg"
                    });
                } else {
                    this.send(AnalyticEmotion(inputText), 1)
                }
            },
            send(content) {//发送评论
                let that = this;
                this.$post("add-comment", {
                    activity_id: this.id,
                    member_id: this.USER().id,
                    content: content,
                }).then(res => {
                    layer.open({
                        content: "评论成功",
                        time: true,
                        skin: "msg"
                    });
                    $(".inpu_div").val('');
                    setTimeout(() => {
                        that.page = 1;
                        that.getComment();
                    }, 1000)
                }).catch(error => {
                     
                    layer.open({
                        content: error.message,
                        time: 2,
                        skin: "msg"
                    });
                });
            },


            //   获取详情信息
            getDetails() {
                let that = this;
                this.$post("activity-view", {
                    activity_id: this.id,
                    member_id: this.USER().id,
                }).then((res) => {
                     
                    if (res.data) {
                        res.data.file = res.data.file.split(",");
                        that.details = res.data;
                        that.getShare(that.details.title, that.details.cover ? that.details.cover : '');
                        that.$nextTick(() => {
                            that.addImg();
                        });
                    }
                });
            },
            getComment() {
                //获取评论
                let that = this;
                if (this.page == 1) {
                    this.comment = [];
                }
                this.$post("activity-comment", {
                    activity_id: this.id,
                    limit: 10,
                    page: this.page,
                }).then((res) => {
                    that.comment_total = res.data.total;
                    that.comment = that.comment.concat(res.data.data);
                });
            },
        },
        mounted() {
            this.id = this.$route.query.id;
            window.upImg = this.upImg;
            this.getDetails();
            this.getComment();
            $(".expression").SinaEmotion($(".inpu_div"));
            $(".expression").click(function () {
                $("#emotions").css({
                    left: "50%",
                    width: "436px",
                    bottom: "0",
                    transform: "translate(-50%,-50px)",
                    top: "auto",
                    "z-index": "999",
                });
            });


            if (this._isMobile()) {

            } else {
                // alert("pc端");
                this.$router.push({ path: '/activitiesDetails', query: { id: this.id } });
            }
            let that = this;
            $(window).scroll(function () {
                var scrollTop = $(this).scrollTop();
                var scrollHeight = $(document).height();
                var windowHeight = $(this).height();
                if (scrollTop + windowHeight + 2 >= scrollHeight) {
                    that.page++;
                    that.getComment();
                }
            });
        }

    };
</script>
<style scoped>
    html,
    body {
        max-width: 100vw;
    }


    .visible-xs {
        width: 100vw;
        overflow: hidden;
        padding-top: 0rem;
    }
    .prompt{
        font-size: 1.2rem;
        color:#777;
        margin-right: .5rem;
    }
    /* 内容 */
    .recommended_head {
        padding: 1rem 1.5rem;
    }

    .recommended_head .recommended_title {
        font-size: 1.6rem;
        color: #2B2B2B;
        font-weight: bold;
    }

    .recommended_head .recommended_title .tag {
        height: 2.1rem;
        min-width: 4rem;
        padding: 0 .5rem;
        border-radius: .5rem;
        border: .1rem solid #EC865B;
        background: #EC865B;
        font-size: 1rem;
        color: #fff;
        margin-right: 1rem;
        white-space: nowrap;
    }

    .recommended_head .author {
        margin-top: 1.4rem;
        align-items: flex-start;
    }

    .recommended_head .author .original {
        color: #666;
        font-size: 1.4rem;
    }

    .recommended_center {
        padding: 1.2rem 1.6rem;
        font-size: 1.5rem;
        color: #333;

    }

    .author .time {
        white-space: nowrap;
    }

    .video_view {
        width: calc(100vw - 3rem);
        margin: 1rem auto;

    }

    .video_view>video {
        width: 100%;
    }

    .comments {
        padding: 1rem 1.3rem 0 1.3rem;
        border-top: .05rem solid #A0A0A0;
    }

    .comments .comments_title {
        font-size: 1.6rem;
        color: #333;
        font-weight: bold;
    }

    /* 评论记录 */
    .comments_ul {
        padding: 2rem .4rem;
    }

    .comments_ul .comments_li {
        margin-bottom: 1.4rem;
    }

    .comments_li .user_text .portrait {
        width: 2.6rem;
        height: 2.6rem;
        border-radius: 50%;
        overflow: hidden;
        display: inline-flex;
        margin-right: .6rem;
        object-fit: contain;
    }

    .comments_li .user_text .user_name {
        font-size: 1.3rem;
        color: #2D82DB;
        margin-right: 1.2rem;
        line-height: 1.1em;
    }

    .comments_li .user_text .time {
        font-size: 1rem;
        color: #999999;
        line-height: 1.1em;
    }

    .comments_li .text_center {
        margin-top: .8rem;
        padding-left: 3.2rem;
        font-size: 1.2rem;
        color: #333;
        line-height: 1.6em;
    }

    .comments_li .text_center img {
        max-width: 60%;
    }

    .container {
        padding: 0 1.3rem;
        width: calc(100% - 2.6rem);
        margin: 0 auto;
    }

    .container .img_li {
        width: 100%;
        margin: 0 auto;
    }

    .container .img_li img {
        width: 100%;
    }

    .time {
        font-size: 1.1rem;
        color: #666;
        margin-top: 1rem;
    }

    .goods_botton {
        font-size: 1.1rem;
        color: #333;
        line-height: 1.1em;
    }

    .goods_botton>i {
        width: 1.5rem;
        margin-right: .6rem;
    }

    /* 底部按钮 */
    .button_buttom {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 0 1.7rem;
        height: 5rem;
        box-shadow: -.4rem 0 1rem rgba(0, 0, 0, .1);
        background: #fff;
    }

    .button_buttom i {
        width: 2rem;
        margin: 0 auto;
    }

    .button_buttom span {
        font-size: 1.2rem;
        color: #666;
        line-height: 1em;
        white-space: nowrap;
    }

    .button_buttom .button_left {
        font-size: 1.2rem;
        color: #888;
    }

    .button_buttom .button_left>i {
        margin-right: .45rem;
        width: 1.8rem;
        height: 1.8rem;
    }

    .button_buttom .button_right {
        flex: 1;
        overflow: hidden;
        margin-left: 1rem;
        border-radius: .5rem;
        height: 3.4rem;
        border: .1rem solid #E5E5E5;
    }

    .button_buttom .button_right .icon_img {
        width: 2.4rem;
        height: 2.4rem;
        margin-left: .6rem;
    }

    .button_buttom .button_right .inpu_div {
        flex: 1;
        height: 100%;
        margin: 0 .6rem;
        font-size: 1.5rem;
    }

    .button_buttom .button_right .send {
        width: 6rem;
        height: 100%;
        color: #fff;
        background: #F24D5B;
        font-size: 1.6rem;
        border: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/minActivity/m_activityDetails.vue